<script setup lang="ts">
import AppIcon from '@/components/ui/AppIcon.vue'
import type { StatusStep } from '@/constants/mockOrderStatus'

/**
 * Степпер статуса: дорожка 358×10 r50 и кружки 40×40 поверх неё. Плашки все
 * одинаково светлые, цветом отличается только иконка: пройденные шаги чёрные,
 * будущие серые. Текущий шаг — жёлтый кружок, тоже с чёрной иконкой.
 */
interface Props {
  steps: StatusStep[]
  current: number
}

defineProps<Props>()
</script>

<template>
  <div class="status-stepper">
    <span class="status-stepper__track" />
    <span
      v-for="(step, index) in steps"
      :key="step.icon"
      class="status-stepper__dot"
      :class="{
        'status-stepper__dot--done': index < current,
        'status-stepper__dot--active': index === current,
      }"
    >
      <AppIcon :name="step.icon" :size="24" />
    </span>
  </div>
</template>

<style scoped lang="scss">
.status-stepper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;

  /* Дорожка по макету сплошная и светлая: пройденный путь она не закрашивает */
  &__track {
    position: absolute;
    top: 15px;
    right: 0;
    left: 0;
    height: 10px;
    border-radius: var(--radius-pill);
    background: var(--surface-muted);
  }

  &__dot {
    position: relative;
    display: flex;
    flex: 0 0 40px;
    align-items: center;
    justify-content: center;
    height: 40px;
    border-radius: var(--radius-round);
    background: var(--surface-muted);
    /* Будущие шаги приглушены — по макету это #abadb0 */
    color: var(--text-color-secondary);

    /* Пройденный шаг отличается только иконкой, плашка остаётся светлой */
    &--done {
      color: var(--text-color);
    }

    /* На жёлтом иконка почти чёрная, замерено по макету */
    &--active {
      background: var(--accent-500);
      color: var(--text-color);
    }
  }
}
</style>
